export default __webpack_public_path__ + "static/media/copy.22eacc47.svg";